// context/AppContext.js - Global state management
import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export function useAppContext() {
  return useContext(AppContext);
}

export function AppProvider({ children }) {
  const [activeFeature, setActiveFeature] = useState('furniture-inpainting');
  const [isLoading, setIsLoading] = useState(false);

  // Common state that might be used across components
  const [originalImage, setOriginalImage] = useState(null);
  const [resultImage, setResultImage] = useState(null);
  
  const value = {
    activeFeature,
    setActiveFeature,
    isLoading,
    setIsLoading,
    originalImage,
    setOriginalImage,
    resultImage,
    setResultImage
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
